import Need from "../Need";

export const NeedCatalogsView = new Need('catalogs.view');
export const NeedCatalogsManage = new Need('catalogs.manage');
